import React from "react";
import "./project.css";
import { Link } from "react-router-dom";
import video from "../video.mp4";

const Todo = () => {
    return (
        <div className="container">
            <div className="nav-left nav-left-alt">
                <div className="nav-left-item">
                    <Link to="/work" className="nav-left-link is-black">
                        WORK
                    </Link>
                </div>

                <div className="nav-line is-black"></div>

                <div className="nav-left-item nav-copyright">
                    <div className="copyright">©/2022</div>
                </div>
            </div>

            <div className="content content-work">
                <div className="header-mask header-mask-large">
                    <h1 className="header header-large">To-Do</h1>
                </div>
            </div>

            <div className="wrapper wrapper-small wf-section">
                <div className="work-container">
                    <div className="description-mask">
                        <p className="description description-large">
                            Daily Planner
                        </p>
                    </div>
                    <figure className="w-richtext-figure-type-image w-richtext-align-fullwidth">
                        <div>
                            <img
                                src="https://i.://ibb.co/NyQfRTr/todo.jpg"
                                alt="projectimg"
                            />
                        </div>
                    </figure>

                    <p className="description">
                        <br></br>On this project my goal was to highlight and
                        practice DOM manipulating in Javascript. Check code
                        on&nbsp;
                        <a
                            href="https://github.com/Mileristov"
                            target="_blank"
                            rel="noreferrer"
                            class="link-blue"
                        >
                            Github.
                        </a>
                    </p>
                </div>
            </div>
            <div className="videos">
                <div className="laptop">
                    <div className="video w-embed">
                        <video
                            width={"100%"}
                            height="auto"
                            autoPlay
                            loop
                            playsInline
                            muted
                        >
                            <source src={video} type="video/mp4"></source>
                        </video>
                    </div>
                </div>
            </div>
            <div className="wrapper wrapper-small wf-section">
                <div className="content-footer">
                    <blockquote class="call-to-action">
                        Check it out.
                    </blockquote>
                    <a
                        href="https://milestodo.netlify.app/"
                        target="_blank"
                        rel="noreferrer"
                        class="button w-button"
                    >
                        https://milestodo.netlify.app/
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Todo;
